export default
{
  "questions": [
    {
      "question": "Who created the javascript language?",
      "id": 1,
      "rightAnswerId": 1,
      "answers": [
        {
          "text": "Brendan Eich",
          "id": 1,
        },
        {
          "text": "Rasmus Lerdorf",
          "id": 2,
        },
        {
          "text": "James Gosling",
          "id": 3,
        },
        {
          "text": "Bjarne Stroustrup",
          "id": 4,
        }
      ]
    },
    {
      "question": "When is Ukraine's Independence Day celebrated?",
      "id": 2,
      "rightAnswerId": 4,
      "answers": [
        {
          "text": "8 March",
          "id": 1
        },
        {
          "text": "3 december",
          "id": 2
        },
        {
          "text": "11 September",
          "id": 3
        },
        {
          "text": "24 August",
          "id": 4
        }
      ]
    },
    {
      "question": "In which hook do you need to download data from the server?",
      "id": 3,
      "rightAnswerId": 4,
      "answers": [
        {
          "text": "UseContext",
          "id": 1
        },
        {
          "text": "UseMemo",
          "id": 2
        },
        {
          "text": "UseState",
          "id": 3
        },
        {
          "text": "UseEffect",
          "id": 4
        }
      ]
    },
    {
      "question": "How many legs does a spider have?",
      "id": 4,
      "rightAnswerId": 4,
      "answers": [
        {
          "text": "4",
          "id": 1
        },
        {
          "text": "2",
          "id": 2
        },
        {
          "text": "6",
          "id": 3
        },
        {
          "text": "8",
          "id": 4
        }
      ]
    },
    {
      "question": "The building blocks of any React application?",
      "id": 5,
      "rightAnswerId": 2,
      "answers": [
        {
          "text": "Bricks",
          "id": 1
        },
        {
          "text": "Components",
          "id": 2
        },
        {
          "text": "Pipes",
          "id": 3
        },
        {
          "text": "Еhe lists",
          "id": 4
        }
      ]
    },
    {
      "question": "Components that are not re-rendered when their state and props are updated with the same values?",
      "id": 6,
      "rightAnswerId": 4,
      "answers": [
        {
          "text": "Small components",
          "id": 1
        },
        {
          "text": "Hybrid components",
          "id": 2
        },
        {
          "text": "Dirty components",
          "id": 3
        },
        {
          "text": "Pure Components",
          "id": 4
        }
      ]
    },
    {
      "question": "What is the largest ocean on Earth in terms of area and depth?",
      "id": 7,
      "rightAnswerId": 2,
      "answers": [
        {
          "text": "Indian Ocean",
          "id": 1
        },
        {
          "text": "Pacific Ocean",
          "id": 2
        },
        {
          "text": "Atlantic Ocean",
          "id": 3
        },
        {
          "text": "Arctic Ocean",
          "id": 4
        }
      ]
    },
    {
      "question": "The world's largest investor as well as the most famous?",
      "id": 8,
      "rightAnswerId": 4,
      "answers": [
        {
          "text": "Jeff Bezos",
          "id": 1
        },
        {
          "text": "Elon Musk",
          "id": 2
        },
        {
          "text": "Bernard Arnault",
          "id": 3
        },
        {
          "text": "Warren Buffett",
          "id": 4
        }
      ]
    },
    {
      "question": "Which language is NOT Indo-European?",
      "id": 9,
      "rightAnswerId": 1,
      "answers": [
        {
          "text": "Hungarian",
          "id": 1
        },
        {
          "text": "Russian",
          "id": 2
        },
        {
          "text": "Greek",
          "id": 3
        },
        {
          "text": "Latvian",
          "id": 4
        }
      ]
    },
    {
      "question": "The Mexican Beer \"Corona\" is what type of beer?",
      "id": 10,
      "rightAnswerId": 3,
      "answers": [
        {
          "text": "India Pale Ale",
          "id": 1
        },
        {
          "text": "Pilfsner",
          "id": 2
        },
        {
          "text": "Pale Lager",
          "id": 3
        },
        {
          "text": "Baltic Porter",
          "id": 4
        }
      ]
    },
    {
      "question": "Which language is NOT Indo-European?",
      "id": 11,
      "rightAnswerId": 1,
      "answers": [
        {
          "text": "Hungarian",
          "id": 1
        },
        {
          "text": "Russian",
          "id": 2
        },
        {
          "text": "Greek",
          "id": 3
        },
        {
          "text": "Latvian",
          "id": 4
        }
      ]
    },
    {
      "question": "What is the name of the author of this application?",
      "id": 12,
      "rightAnswerId": 3,
      "answers": [
        {
          "text": "Vyacheslav",
          "id": 1
        },
        {
          "text": "Yaroslav",
          "id": 2
        },
        {
          "text": "Rostislav",
          "id": 3
        },
        {
          "text": "Kostyantyn",
          "id": 4
        }
      ]
    },
  ]
}